import { css } from '@fluentui/react';
import { FC, ReactNode } from 'react';
import { getClassNames } from './header.styles';

export const Header: FC<{ children?: ReactNode; className?: string }> = ({ children, className }) => {
    const classNames = getClassNames();
    return <div className={css(classNames.header, className)}>{children}</div>;
};
